import tinytime from 'tinytime'

export function formatDate(date, format) {
  // Check if date is null or undefined
  if (date === null || date === undefined) {
    return '' // or return a default value like 'N/A' or current date
  }

  // Try to create a valid date object
  const dateObj = typeof date === 'string' ? new Date(date) : date

  // Check if the date is valid
  if (isNaN(dateObj.getTime())) {
    return '' // or return a default value
  }

  return tinytime(format, { padMonth: true })
    .render(dateObj)
    .replace('Febuary', 'February')
}
